import React, { Fragment } from 'react'
import EditBtn from '../../buttons/EditBtn'
import DeleteBtn from '../../buttons/DeleteBtn'
import { dateToDayMonthYearAndHour } from '../../../utils/date'
import NullMssg from '../../common/NullMssg'
import _ from 'lodash'
import { mssgs } from '../../../constantes/mssgs'

const TaskHistory = ({ allUserTasks, handleRemove, toEditTask }) => {
  let classActiveChange = 'products__text'
  let classActiveChangeType = 'products__text-type'
  let style = { visibility: 'visible' }

  const allTask = _.orderBy(allUserTasks, ['fecha'], ['desc']) // Ordenar por fecha descendente

  return allTask.length > 0 ? (
    <Fragment>
      <div className='table-wrapper'>
        <table className='tasks-table'>
          <thead>
            <tr>
              <th className="table-th-date">
                Fecha
              </th>
              <th style={{ minWidth: '160px', width: '160px'}}>
                Contacto
              </th>
              <th style={{ minWidth: '140px', width: '140px'}}>
                Tipo asunto
              </th>
              <th style={{ minWidth: '140px', width: '140px'}}>
                Asunto
              </th>
              <th style={{ minWidth: '120px', width: '120px'}}>
                Fase
              </th>
              <th style={{ minWidth: '160px', width: '160px'}}>
                Evento relacionado
              </th>
              <th style={{ minWidth: '120px', width: '120px'}}>
                Hospital / Centro
              </th>
              <th style={{ minWidth: '120px', width: '120px'}}>
                Especialidades
              </th>
              <th style={{ minWidth: '120px', width: '120px'}}>
                Descripción
              </th>
              <th className="table-th-created">
                Calendario?
              </th>
              <th className="table-th-created">
                Creado
              </th>
              <th className="table-th-actions" style={{ width: '120px', minWidth: '120px'}}>
                Acciones
              </th>
            </tr>
          </thead>
          <tbody>
            {allTask.length > 0
              ? allTask.map((task) => {
                  {
                    if (!task.contacto || task.contacto_isActivo === false) {
                      classActiveChange = 'products__text-readOnly'
                      classActiveChangeType = 'products__text-readOnly'
                      style = { visibility: 'hidden' }
                    } else {
                      classActiveChange = 'products__text'
                      classActiveChangeType = 'products__text-type'
                      style = { visibility: 'visible' }
                    }
                  }
                  return (
                    <tr key={task.id_Crm}>
                      <td className="table-td-date">
                          {task.fecha.split(' ')[0]}
                      </td>
                      <td className="table-td-header">
                        {task.contacto}
                      </td>
                      <td style={{ fontSize: '90%'}}>
                        {task.tipoAsunto}
                      </td>
                      <td className="table-td-header" style={{ fontSize: '90%'}}>
                        {task.asunto}
                      </td>
                      <td style={{ fontSize: '90%'}}>
                          {task.tipoFase}
                      </td>
                      <td style={{ fontSize: '90%'}}>
                        {task.evento}
                      </td>
                      <td className="table-td-ellipsis" style={{ fontSize: '90%'}}>
                        {task?.hospitales}
                      </td>
                      <td className="table-td-ellipsis" style={{ fontSize: '90%'}}>
                          {task?.especialidades}
                      </td>
                      <td className="table-td-ellipsis" style={{ fontSize: '90%'}}>
                          {task.descripcion}
                      </td>
                      <td className="table-td-calendar" style={{ fontSize: '90%'}}>
                        {task && task.isVerCaledario ? 'Sí' : ''}
                      </td>
                      <td className="table-td-created">
                          {dateToDayMonthYearAndHour(task.fechaCreacion)}<br />
                          {task && task.usuario ? task.usuario : ''}
                      </td>

                      <td className="table-td-actions">
                        <button onClick={() => toEditTask(task.id_Crm)}>
                          <EditBtn />
                        </button>
                        <button onClick={() => handleRemove(task.id_Crm)}>
                          <DeleteBtn />
                        </button>
                      </td>
                    </tr>
                  )
                })
              : null}
          </tbody>
        </table>
      </div>
    </Fragment>
  ) : (
    <NullMssg
      mssg={
        mssgs && mssgs.NADA_QUE_MOSTRAR_AÑADIR_TAREA
          ? mssgs.NADA_QUE_MOSTRAR_AÑADIR_TAREA
          : 'No hay leads que mostrar'
      }
    />
  )
}

export default TaskHistory
